module.exports = __webpack_public_path__ + "img/login-background1.46ccf009.jpg";